export const PUBLIC_ROUTE = {
  LOGIN: "/ingresar",
  UNAUTHORIZED: "/no-autorizado",
  NO_ENCONTRADA: "/no-encontrada",
  ACCESO_DENEGADO: "/acceso-denegado",
  ACCESO_RESTRINGIDO: "/acceso-restringido",
};
